<template>
  <div>
    <transition name="model">
      <form @submit.prevent="submitForm">
        <div class="modal_mask">
          <div class="modal_content">
            <div class="modal_header">
              <div class="title_modal">
                <div class="flex">
                  <h4>Editar item de Checklist</h4>
                </div>
              </div>
            </div>
            <div class="modal-body">
              <div class="padding">
                <div>
                  <label class="col-form-label font-weight-bold">
                    Descrição
                  </label>
                  <input
                    v-model="v$.decricao.$model"
                    type="text"
                    :class="['form-control', { error: v$.decricao.$error }]"
                  />

                  <div class="text-red" v-if="v$.decricao.$error">
                    O campo Descrição é obrigatório.
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-light font-weight-bold"
                @click="ModalCancelar"
                data-dismiss="modal"
              >
                Cancelar
              </button>
              <button
                type="button"
                class="btn btn-light font-weight-bold"
                style="background: #5dbb83; color: #fff"
                @click="submit"
              >
                Salvar
              </button>
            </div>
          </div>
        </div>
      </form>
    </transition>
  </div>
</template>


<script>
import useVuelidate from "@vuelidate/core";
import { required, minLength } from "@vuelidate/validators";
import { PutDataItem } from "../../../../controllers/ItemsChecklist/PutDataItem";
import { GetFindAllDataItem } from "../../../../controllers/ItemsChecklist/GetFindAllDataItem";
export default {
  props: {
    list: false,
  },
  data() {
    return {
      v$: useVuelidate(),
      decricao: "",
      id: Number,
      imageData: undefined,
      imageDataFile: [],
      modalView: false,
    };
  },

  validations() {
    return {
      decricao: {
        required,
        minLength: minLength(4),
      },
    };
  },

  methods: {
    async submit() {
      const isFormCorrect = await this.v$.$validate();

      if (!isFormCorrect) {
        return;
      }

      const toast = await this.$swal
        .fire({
          title: "Deseja editar Item?",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "green",
          cancelButtonColor: "#d33",
          confirmButtonText: "Confirmar",
        })
        .then((result) => {
          if (result.isConfirmed) {
            return true;
          }

          return false;
        });

      if (!toast) {
        return;
      }

      const res = await PutDataItem(this.id, { desc: this.decricao });
      if (res.status == 201) {
        const Toast = await this.$swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
          },
        });

        const result = await GetFindAllDataItem();
        if (result != undefined) {
          this.$store.commit("SetListItems", result.data.list);
        }

        Toast.fire({
          icon: "success",
          title: res.data.message,
        });
      }
      this.$store.commit("MutationSetCancelModaItemCheckllist", false);
    },
    getFile(event) {
      // Referência ao elemento de entrada DOM
      var input = event.target;
      // Certifique-se de que possui um arquivo antes de tentar lê-lo
      if (input.files && input.files[0]) {
        this.imageDataFile = input.files[0];

        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // crie um novo FileReader para ler esta imagem e converter para o formato base64
        reader.onload = (e) => {
          // Note: função de seta usada aqui, de modo que "this.imageData" se refira ao componente imageData do Vue
          // Leia a imagem como base64 e defina como imageData
          this.imageData = e.target.result;
        };
        // Inicie o trabalho do leitor - leia o arquivo como url de dados (formato base64)
        reader.readAsDataURL(input.files[0]);

        //Acionar $Emit para enviar o objeto quando um File for adicionado
      }
    },

    resetFile() {
      this.imageData = null;
      this.imageDataFile = [];
    },

    activeView() {
      this.modalView = !this.modalView;
    },

    getObjOfInforGeral(val) {
      this.dados.InforGeral = val;
    },

    getListPro(val) {
      this.dados.Produtos = val;
    },

    getObjAllImages(val) {
      this.dadosImages = val;
    },

    getObjMoldeFechado(val) {
      this.dados.Molde_Fechado = val;
    },

    getObjMoldeAberto(val) {
      this.dados.Molde_Aberto = val;
    },
    async ModalCancelar() {
      const toast = await this.$swal
        .fire({
          title: "Deseja cancelar edição ?",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "green",
          cancelButtonColor: "#d33",
          confirmButtonText: "Confirmar",
        })
        .then((result) => {
          if (result.isConfirmed) {
            return true;
          }

          return false;
        });

      if (!toast) {
        return;
      }

      this.$store.commit("MutationSetCancelModaItemCheckllist", false);
    },
  },
  watch: {
    list(newValue) {
      this.decricao = newValue.DESC;
      this.id = newValue.ID;
    },
  },
};
</script>


<style scoped>
input:disabled {
  background: #6666663d;
}

.padding {
  padding: 40px;
}
.flex-flex {
  display: flex;
}

.flex-img {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.lixo {
  background: var(--red);
  font-size: 25px;
  /* text-align: center; */
  align-items: center;
  justify-content: center;
  display: flex;
}

.modal-open {
  overflow: hidden;
}

ul li {
  cursor: pointer;
}
.modal-body {
  width: 100%;
}

.card_end {
  justify-content: flex-end;
  display: flex;
}
.flex {
  display: flex;
  justify-content: space-between;
}

.title_modal input {
  width: 2vw;
  height: 2vw;
  border-radius: 8px;
  background: var(--red);
  color: var(--white);
  border: none;
  font-size: 0.8vw;
}
.title_modal input:hover {
  width: 2vw;
  height: 2vw;
  border-radius: 8px;
  background: var(--red);
  color: var(--white);
  border: none;
  font-size: 0.8vw;
}

.modal_mask {
  position: fixed;
  display: block;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: auto;
   background:#c5c5c5d6;
  overflow: auto;
  
}

.modal_mask .modal_content {
  position: relative;
  width: 45%;
  /* height: 90%;   TAMANHO DE CARRAGAER NOVO RRIM*/
  margin: 30px auto;
  background: var(--white);
  border-radius: 20px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
}

.modal_mask .modal_content .modal_header {
  width: 100%;
  height: 3.5rem;
  line-height: 3.5rem;
  background: var(--green);
  /* background: rgb(239 224 49); */
  border-top-left-radius: 18px;
  border-top-right-radius: 18px;
}

.modal_mask .modal_content .modal_header .title_modal {
  width: 90%;
  margin: auto;
  color: var(--white);
  font-size: 1.5rem;
  text-align: start;
  align-items: center;
  justify-content: space-between;
}

.column_1 {
  overflow-y: scroll;
}

.column_2 {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.modal_mask .modal_body {
  width: 98%;
  /* height: 90%; */
  margin: auto;
  position: relative;
  top: 0;
  left: 0;
  /* overflow-y: scroll; */
  padding: 0 15px;
  display: grid;
  gap: 1vw;
  grid-template-columns: 3.7fr 1fr;
}

.modal_mask .modal_body .cards {
  width: 100%;
  grid-column: 1/4;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 15px;
  text-align: start;
}

.modal_mask .modal_body .cards .card_informations {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: var(--white);
  padding: 20px;
  border-radius: 10px;
}

.nav-link {
  display: block;
  padding: 0.5rem 1rem;
}
.font-weight-bold {
  font-weight: 700 !important;
}

.mx-3 {
  margin-left: 1rem !important;
}

.modal_mask .modal_body .cards .card_informations .title {
  width: 100%;
  color: var(--green);
}

.nav-pills .nav-link {
  border-radius: 0.35rem;
}

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--white);
  background-color: var(--green);
}

.modal_mask .modal_body .button_modal {
  width: 100%;
  position: relative;
  grid-column: 1/4;
  display: grid;
  grid-template-columns: 1fr;
  justify-content: flex-end;
  padding: 25px;
  justify-items: end;
  display: flex;
}

.table-content {
  overflow-y: scroll;
  /* height: 20
rem
; */
  height: 80vh;
}

.card-header {
  width: 100%;
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: var(--white);
  border-bottom: 1px solid var(--grayBody);
}

.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-tabs .nav-link.active {
  color: var(--greyBtn);
  background-color: var(--white);
  border-color: #dddfeb #dddfeb #fff;
}
.nav-tabs .nav-link {
  border: 1px solid transparent;
  border-top-left-radius: 0.35rem;
  border-top-right-radius: 0.35rem;
}
.text-success {
  color: var(--green) !important;
}
.font-weight-bold {
  font-weight: 700 !important;
}
.nav-link {
  display: block;
  padding: 0.5rem 1rem;
}
a {
  color: var(--green);
  text-decoration: none;
  background-color: transparent;
}

.nav-tabs .nav-item {
  margin-bottom: -1px;
}

.modal-footer {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: 0.75rem;
  border-top: 1px solid var(--greyBtn);
  border-bottom-right-radius: calc(0.3rem - 1px);
  border-bottom-left-radius: calc(0.3rem - 1px);
}

input[type="file"] {
  display: none;
}

.palavra {
  background-color: var(--blue);
  border-radius: 5px;
  color: var(--white);
  cursor: pointer;
  margin: 10px;
  padding: 6px 10px;
}

.palavra.button-success {
  background-color: var(--green);
}

.error {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--inputColor);
  background: var(--redTransparent);
  background-clip: padding-box;
  border: 1px solid var(--greyBtn);
  border-radius: 0.35rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.text-red {
  color: var(--redTransparent);
  font-size: 12px;
  margin-top: 2px;
}

.error:focus {
  color: var(--inputColor);
  background-color: var(--white);
  border-color: var(--red);
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgb(9 243 107 / 25%);
}

.valid {
  border-color: var(--darkgreen);
  background: var(--white);
}

.valid:focus {
  outline-color: var(--darkgreen);
}

hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid var(--black);
}

@media (max-width: 1240px) {
  .modal_mask .modal_body .cards {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 1100px) {
  .modal_mask .modal_body .button_modal {
    grid-template-columns: 3fr 1fr;
  }
}

@media (max-width: 907px) {
  .modal_mask .modal_body .cards {
    grid-template-columns: 1fr;
  }

  .modal_mask .modal_body .button_modal {
    grid-template-columns: 2fr 1fr;
  }
}

@media (max-width: 780px) {
  .modal_mask .modal_body .title {
    text-align: center;
  }
  .modal_mask .modal_body .button_modal {
    grid-template-columns: 1fr;
    padding: 15px 0;
    grid-gap: 10px;
    display: flex;
    flex-direction: column;
  }
}

@media (max-width: 768px) and (min-width: 426px) {
  .modal_mask .modal_content {
    width: 95%;
    font-size: 12px;
    position: relative;
    /* width: 65%; */
    margin: 30px auto;
    background: var(--white);
    border-radius: 20px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
  }
}

@media (max-width: 425px) {
  .modal_mask .modal_content {
    width: 95%;
    font-size: 12px;
    position: relative;
    /* width: 65%; */
    margin: 30px auto;
    background: var(--white);
    border-radius: 20px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
  }
}
</style>
